import { useState, useContext, useEffect } from "react";
//import './Register.css'; // Optional, for specific styles
import { BarbershopContext } from "../../providers/useProvider";
import { Link } from "react-router-dom";
import AlertMessage from "../../components/AlertMessage";

import useRegister from "../../hooks/useRegister";
const Register = () => {
  const { register, loading, message, setShowMessage, showMessage } =
    useRegister();
  const { config } = useContext(BarbershopContext);
  const [form, setForm] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };
  function validatePassword(value) {
    const lower = /[a-z]/.test(value);
    const upper = /[A-Z]/.test(value);
    const symbol = /[^a-zA-Z0-9]/.test(value);
    const length = value.length >= 8 && value.length <= 20;
    return lower && upper && symbol && length;
  }
  const validate = () => {
    const newErrors = {
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      phoneNumber: "",
    };
    var flag = true;
    if (!form.email.match(/^\S+@\S+\.\S+$/)) {
      newErrors.email = "Invalid email.";
      flag = false;
    }
    if (!(form.password.length >= 8 && form.password.length <= 20)) {
      newErrors.password = "Password too short.";
      flag = false;
    }

    if (!validatePassword(form.password)) {
      newErrors.password = "Must include: uppercase, lowercase, symbol.";
      flag = false;
    }

    if (form.password !== form.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match.";
      flag = false;
    }

    if (!form.firstName) {
      newErrors.firstName = "First name is required.";
      flag = false;
    }
    if (!form.lastName) {
      newErrors.lastName = "Last name is required.";
      flag = false;
    }

    if (!form.phoneNumber.match(/^\d{8,12}$/)) {
      newErrors.phoneNumber = "Invalid phone number.";
      flag = false;
    }

    setErrors(newErrors);
    return flag;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    let barbershop = config.barbershopName;
    await register(form, barbershop);
  };

  if (config) {
    return (
      <div className="d-flex justify-content-center h-100">
        <div className="d-flex align-items-center">
          <div class="login-card row g-0 shadow-lg">
            <div className="row g-0">
              <div className="col-md-6 image-side">
                <div>
                  <h2>Find your sweet home</h2>
                  <p>
                    Schedule visits in just a few clicks.
                    <br />
                    Your dream property awaits.
                  </p>
                </div>
              </div>

              <div className="col-md-6 d-flex align-items-center justify-content-center form-side">
                <div className="w-100">
                  {showMessage && (
                    <AlertMessage
                      key={message.text}
                      setVisible={setShowMessage}
                      message={message.text}
                      type={message.type}
                      duration={4000}
                    />
                  )}
                  <h4 className="login-title mb-2 text-color">
                    Create an account
                  </h4>

                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label className="form-label">First Name</label>
                      <input
                        type="text"
                        name="firstName"
                        className={`form-control  login-input  ${
                          errors.firstName && "is-invalid"
                        }`}
                        value={form.firstName}
                        onChange={handleChange}
                      />
                      {errors.firstName && (
                        <div className="invalid-feedback">
                          {errors.firstName}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Last Name</label>
                      <input
                        type="text"
                        name="lastName"
                        className={`form-control login-input  ${
                          errors.lastName && "is-invalid"
                        }`}
                        value={form.lastName}
                        onChange={handleChange}
                      />
                      {errors.lastName && (
                        <div className="invalid-feedback">
                          {errors.lastName}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Phone Number</label>
                      <input
                        type="text"
                        name="phoneNumber"
                        className={`form-control  login-input ${
                          errors.phoneNumber && "is-invalid"
                        }`}
                        value={form.phoneNumber}
                        onChange={handleChange}
                      />
                      {errors.phoneNumber && (
                        <div className="invalid-feedback">
                          {errors.phoneNumber}
                        </div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        name="email"
                        className={`form-control  login-input ${
                          errors.email && "is-invalid"
                        }`}
                        value={form.email}
                        onChange={handleChange}
                      />
                      {errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Password</label>
                      <input
                        type="password"
                        name="password"
                        className={`form-control  login-input ${
                          errors.password && "is-invalid"
                        }`}
                        value={form.password}
                        onChange={handleChange}
                      />
                      {errors.password && (
                        <div className="invalid-feedback">
                          {errors.password}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>
                      <input
                        type="password"
                        name="confirmPassword"
                        className={`form-control  login-input ${
                          errors.confirmPassword && "is-invalid"
                        }`}
                        value={form.confirmPassword}
                        onChange={handleChange}
                      />
                      {errors.confirmPassword && (
                        <div className="invalid-feedback">
                          {errors.confirmPassword}
                        </div>
                      )}
                    </div>
                    <div className="d-flex mb-3">
                      <Link
                        to="/login"
                        className="btn btn-secondary w-25  me-auto p-2"
                        role="button"
                      >
                        Back
                      </Link>

                      <button
                        type="submit"
                        className="btn btn-primary p-2 w-25"
                        disabled={loading}
                      >
                        {loading ? "Registering..." : "Register"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    <div>Loading...</div>;
  }
};

export default Register;
